package app.alefly.core.auth

const val CALLABLES_FIREBASE_PROJECT_ID = "alefly-ac6b2"

data class CallableAuthPlan(val authorizationHeader: String?, val dataIdToken: String?)

// Dual auth contract: the built-in onCall Authorization-header check only ever verifies
// against the hub project -- when it already found a valid hub token, use it unchanged
// (every non-migrated tenant, and any migrated-tenant caller that still happens to send
// a hub token, is untouched by this function). Otherwise, a satellite-authenticated
// client sends its raw ID token via `data.dataIdToken` instead of the Authorization
// header (the header path would hard-401 before the backend's resolveCallableAuth ever
// runs), verified there against the correct per-tenant project.
//
// Shared between app/web and shared/mobile (both already depend on :shared:core) so web
// and mobile can never silently drift on which auth contract they speak to the same
// backend -- this used to be two byte-for-byte identical copies.
fun resolveCallableAuthPlan(idToken: String?, isAuthOnHub: Boolean): CallableAuthPlan {
    val trimmed = idToken?.trim()
    if (trimmed.isNullOrBlank()) {
        return CallableAuthPlan(authorizationHeader = null, dataIdToken = null)
    }
    return if (isAuthOnHub) {
        CallableAuthPlan(authorizationHeader = "Bearer $trimmed", dataIdToken = null)
    } else {
        CallableAuthPlan(authorizationHeader = null, dataIdToken = trimmed)
    }
}
